import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { faArrowLeft, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory, useParams } from 'react-router-dom';
import pricingIcon from '../../../assets/img/pricing.png';
import shopingCartIcon from '../../../assets/img/shoppingcart.png';
import DebrifeIcon from '../../../assets/img/debrief.png';
import { t } from '../Translate';
import pieIcon from '../../../assets/img/pie.svg';
import { Auth } from '../../../config/configuration/react';
import getValue from '../../../services/Form/getValue';
import useAuth from '../../../hooks/useAuth0/useAuth';

const SubHeader = (props) => {
  const { formId, recordId: recordIdParam } = useParams();
  const history = useHistory();
  const origin = _.get(history, 'location.state.origin', null);
  const [recordId, setRecordId] = useState(recordIdParam);
  const { page, noBack, iconBackbutton, title, subtitle } = props;
  const icons = {
    market_analysis_title: pieIcon,
    proposition: pricingIcon,
    buy_immediately: shopingCartIcon,
    debrief: DebrifeIcon,
    trade_in_offer_tab: pricingIcon,
  };
  const { authStatus } = useAuth();

  useEffect(() => {
    let mounted = false;
    if (authStatus === 'success') {
      if (mounted) return;
      if (formId) {
        getValue(formId, 'recordId').then((rId) => {
          if (mounted) return;
          if (![0, '0'].includes(rId)) setRecordId(rId);
        });
      }
    }

    // eslint-disable-next-line consistent-return
    return () => {
      mounted = true;
    };
  }, [authStatus]);

  const onBackButtonEvent = (e) => {
    const { location, match, backRoute } = props;
    e.preventDefault();
    if (location.pathname.includes('search')) {
      if (Auth.isOnlyNrmUser()) {
        history.push('/dashboardnrm');
      } else history.push('/forms');
    } else if (location.pathname.startsWith('/files')) {
      if (
        match.path === '/files/:recordId/identification' ||
        match.path === '/files/:recordId/market' ||
        match.path === '/files/:recordId/pushAt' ||
        match.path === '/files/:recordId/pricing' ||
        match.path === '/files/:recordId/finalising' ||
        match.path === '/files/:recordId/garanteed-price'
      )
        history.push({
          pathname: location.state.from,
          state: location.state,
        });
      else if (location.state && location.state.queries === '/forms') history.push('/forms');
      else if (origin)
        history.push({
          pathname: `/${origin}`,
          state: location.state,
        });
      else if (Auth.isOnlyNrmUser()) {
        history.push('/dashboardnrm');
      } else history.push('/forms');
    } else if (location.pathname === '/forms/0/create_new_inspection') {
      history.push({
        pathname: location.state.from,
        state: location.state,
      });
    } else if (location.pathname.includes('report')) {
      history.push({
        pathname: `/files/${recordId[0]}`,
        state: location.state,
      });
    } else if (backRoute) {
      history.push({
        pathname: backRoute,
        state: location.state,
      });
    } else {
      history.goBack();
    }
  };

  return (
    <div className="subHeader">
      <div className="subHeader-bloc">
        {!noBack && (
          <span onClick={onBackButtonEvent} aria-hidden className="icon-back mr-1">
            <FontAwesomeIcon
              className="back-button"
              size="2x"
              icon={iconBackbutton === false ? faTimes : faArrowLeft}
              data-cy="backButton"
            />
          </span>
        )}
        {page && (
          <span className="cursor-pointer">
            <img src={icons[page]} alt="" height="25" className="ml-2 mr-2" />
            <span className="subHeader-page-title">{t(page)}</span>
          </span>
        )}
      </div>
      {title && (
        <div className="subHeader-bloc-2">
          <div className="logo-carcheck">{title !== 'Carcheck' && title}</div>
          {subtitle !== undefined && <div className="subtitle">{subtitle}</div>}
        </div>
      )}
    </div>
  );
};

SubHeader.propTypes = {
  location: PropTypes.shape(),
  match: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  backRoute: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  page: PropTypes.string,
  noBack: PropTypes.bool,
  iconBackbutton: PropTypes.bool,
};
SubHeader.defaultProps = {
  location: undefined,
  match: undefined,
  subtitle: undefined,
  backRoute: undefined,
  page: undefined,
  noBack: false,
  iconBackbutton: undefined,
};

export default SubHeader;
